import { jsxs, jsx } from "react/jsx-runtime";
const IconBedSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M16.665 3.417H3.332a2.5 2.5 0 0 0-2.5 2.5V16.75a.833.833 0 0 0 .833.833H5a.833.833 0 0 0 .691-.375l1.425-2.125h5.767l1.425 2.125a.833.833 0 0 0 .692.375h3.333a.833.833 0 0 0 .833-.833V5.917a2.5 2.5 0 0 0-2.5-2.5Zm.834 12.5h-2.05l-1.425-2.084a.833.833 0 0 0-.692-.416H6.665a.833.833 0 0 0-.691.375l-1.425 2.125h-2.05V11.75h15v4.167ZM5.832 10.083V9.25a.833.833 0 0 1 .833-.833h1.667a.833.833 0 0 1 .833.833v.833H5.832Zm5 0V9.25a.833.833 0 0 1 .833-.833h1.667a.833.833 0 0 1 .833.833v.833h-3.333Zm6.667 0h-1.667V9.25a2.5 2.5 0 0 0-2.5-2.5h-1.667A2.5 2.5 0 0 0 10 7.4a2.5 2.5 0 0 0-1.667-.65H6.665a2.5 2.5 0 0 0-2.5 2.5v.833H2.5V5.917a.833.833 0 0 1 .833-.834h13.333a.833.833 0 0 1 .834.834v4.166Z" })
    ]
  }
);
export {
  IconBedSvg
};
